import React from 'react';
import { confirmAlert } from 'react-confirm-alert'; 
import DefaultLayout from './layouts/Default';

export function Welcome(props) {

    const onClickHandler = (e) => {
        confirmAlert({
            title: 'Confirm to submit',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => alert('Click Yes')
                },
                {
                    label: 'No',
                    onClick: () => alert('Click No')
                }
            ]
        });
    }

    return (
        <div>
            <DefaultLayout>
                <div className="row loginForm">
                    <div className="col-lg-4 col-md-2">
                    </div>
                    <div className="col-lg-4 col-md-8">
                        <div className="card">
                            <div className="card-body">
                                <div className="text-center px-xl-3">
                                    <h1>
                                        Hello, {props.name}
                                    </h1>
 
                                    <button className="btn btn-success btn-block" type="button" onClick={onClickHandler}>Click me!</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-2">
                    </div>
                </div>
            </DefaultLayout>       
        </div>
    );
}
